import { ALLOWED_FILE_TYPES } from "@circle-react-uikit/EmojiPickerV3/Pickers/Custom/constants";
import uniqueId from "lodash/uniqueId";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

interface UseLinkImageUploadArgs {
  uploadFile: (file: File) => void;
}

export const useLinkImageUpload = ({ uploadFile }: UseLinkImageUploadArgs) => {
  const [imageError, setImageError] = useState<string | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const fetchAndUpload = async (url: string) => {
    if (!url) return;
    setIsProcessing(true);
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const contentType = res.headers.get("content-type");

      if (contentType && ALLOWED_FILE_TYPES.includes(contentType)) {
        const file = new File([blob], uniqueId(), {
          type: contentType ?? blob.type,
        });
        uploadFile(file);
        setImageError(null);
      } else {
        setImageError(t("emoji_picker_v3.custom_icon.link_upload.error"));
      }
    } catch {
      setImageError(t("emoji_picker_v3.custom_icon.link_upload.error"));
    } finally {
      setIsProcessing(false);
    }
  };

  return { fetchAndUpload, imageError, isProcessing };
};
